module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Идет процесс создания...":"The address is creating..."}}')
  delete Component.options._Ctor
}
